import './LoadingOverlay.scss';

import { FavoriteRounded } from '@mui/icons-material';
import React from 'react';

import ActivityIndicator from './components/ActivityIndicator';
import Config from './config';
import { readStandaloneDisplayModeFromWindow } from './features/pwa/utils/isStandaloneDisplayMode';

export interface ILoadingOverlayProps {
    /**
     * When true and the app is running as an installed PWA / Home Screen app,
     * show the branded boot splash. Inline loaders (images, routes) stay as spinner.
     */
    brandedSplash?: boolean;
}

/**
 * Default: small spinner (images, Suspense, browser tab).
 * PersistGate: branded splash only while the app is actually booting in standalone.
 * No forced delay — the OS already shows the app icon splash for ~1–2s on PWA open
 * (from manifest icons / background_color / theme_color).
 */
export const LoadingOverlay = ({ brandedSplash = false }: ILoadingOverlayProps) => {
    const isPwaStandalone = typeof window !== 'undefined' && readStandaloneDisplayModeFromWindow(window);
    const showBrandedSplash = brandedSplash && isPwaStandalone;

    if (!showBrandedSplash) {
        return (
            <div className="flex column centered align-items-center justify-content-center">
                <ActivityIndicator />
            </div>
        );
    }

    return (
        <div className="app-boot-splash" role="status" aria-live="polite" aria-label="Laden">
            <div className="app-boot-splash__brand" style={{ color: Config.GLOBAL_PRIMARY_COLOR }}>
                <FavoriteRounded className="app-boot-splash__icon" aria-hidden="true" />
                <span className="app-boot-splash__name">{Config.GLOBAL_SITE_NAME}</span>
            </div>
        </div>
    );
};

export default LoadingOverlay;
